import { useCallback, useEffect, useState } from 'react';
import { getAllSites } from '../SiteManagement/siteApi';
import { getLostFoundSiteId, setLostFoundSiteId } from './lostAndFoundApi';

export const resolveSiteValue = site =>
  site?.site_id ??
  site?.siteId ??
  site?.id ??
  site?._id ??
  site?.site_code ??
  site?.siteCode ??
  '';

export const resolveSiteLabel = site =>
  site?.site_name ?? site?.name ?? site?.site_id ?? site?.id ?? 'Site';

const useLostFoundSite = () => {
  const [siteId, setSiteId] = useState(() => getLostFoundSiteId());
  const [sites, setSites] = useState([]);
  const [isLoadingSites, setIsLoadingSites] = useState(true);
  const [sitesError, setSitesError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setIsLoadingSites(true);
      setSitesError('');
      try {
        const response = await getAllSites();
        const list = Array.isArray(response?.sites)
          ? response.sites
          : Array.isArray(response)
            ? response
            : Array.isArray(response?.data)
              ? response.data
              : [];
        const sorted = [...list].sort((a, b) =>
          resolveSiteLabel(a).localeCompare(resolveSiteLabel(b))
        );
        if (!cancelled) {
          setSites(sorted);
          const stored = getLostFoundSiteId();
          const storedValid =
            stored && sorted.some(s => resolveSiteValue(s) === stored);
          if (storedValid) {
            setSiteId(stored);
          } else if (sorted.length === 1) {
            const only = resolveSiteValue(sorted[0]);
            setSiteId(only);
            setLostFoundSiteId(only);
          }
        }
      } catch (err) {
        if (!cancelled) {
          setSitesError(err.message || 'Failed to load sites');
          setSites([]);
        }
      } finally {
        if (!cancelled) setIsLoadingSites(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const selectSite = useCallback(id => {
    setSiteId(id);
    setLostFoundSiteId(id);
  }, []);

  const selectedSite = sites.find(s => resolveSiteValue(s) === siteId) ?? null;

  return {
    siteId,
    sites,
    selectedSite,
    isLoadingSites,
    sitesError,
    selectSite,
    hasSite: Boolean(siteId),
  };
};

export default useLostFoundSite;
